import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { sections } from './common/sections'
import { scrollToSection } from './common/scrollToSection'
import Home, { HomeProps } from './sections/Home/Home'
import Who from './sections/Who/Who'
import OptIn from './sections/OptIn/OptIn'
import Dates from './sections/Dates/Dates'
import Benefits from './sections/Benefits/Benefits'
import ExclusivePlatform from './sections/ExclusivePlatform/ExclusivePlatform'
import OfferConditions from './sections/OfferConditions/OfferConditions'
import Closure from './sections/Closure/Closure'
import Contact from './sections/Contact/Contact'
import { SectionId } from './common/sectionId'
import * as S from './styled'

type ComponentsMap = {
  inicio: FC<HomeProps>
} & Record<Exclude<SectionId, 'inicio'>, FC>

const componentsMap: ComponentsMap = {
  inicio: Home,
  'quem-pode-participar': Who,
  datas: Dates,
  'adesao-beneficios': OptIn,
  beneficios: Benefits,
  'acesso-plataforma': ExclusivePlatform,
  'condicoes-oferta': OfferConditions,
  encerramento: Closure,
  'central-de-atendimento': Contact
}

const ProgramRulesPage = () => {
  const refs = useRef<Record<SectionId, HTMLDivElement | null>>(
    {} as Record<SectionId, HTMLDivElement | null>
  )

  const [isMenuFixed, setIsMenuFixed] = useState(false)

  const [activeSection, setActiveSection] = useState<string | null>(null)

  const handleScroll = useCallback(() => {
    setIsMenuFixed(window.scrollY >= 770)

    let closestId: string | null = null

    let minDistance = Infinity

    for (const [id, el] of Object.entries(refs.current) as [
      SectionId,
      HTMLDivElement | null
    ][]) {
      if (!el) {
        continue
      }

      const rect = el.getBoundingClientRect()

      const distance = Math.abs(rect.top)

      if (distance < minDistance && rect.top < window.innerHeight) {
        minDistance = distance
        closestId = id
      }
    }

    if (closestId) {
      setActiveSection(closestId)
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  const renderSection = (id: SectionId) => {
    const Component = componentsMap[id]

    return (
      <div key={id} id={id} ref={el => (refs.current[id] = el)}>
        <Component refs={refs} />
      </div>
    )
  }

  return (
    <BrowserRouter>
      <div>
        {isMenuFixed && (
          <S.Menu>
            <S.MenuContainer>
              {sections.map(({ id, label }) => (
                <S.Button
                  key={id}
                  onClick={() => scrollToSection(refs, id as SectionId)}
                  className={activeSection === id ? 'active' : ''}>
                  {label}
                </S.Button>
              ))}
            </S.MenuContainer>
          </S.Menu>
        )}

        {sections.map(({ id }) => renderSection(id as SectionId))}
      </div>
    </BrowserRouter>
  )
}

export default ProgramRulesPage
